import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { visibilityIcon } from '@/constants/images';
import { entityVisibility } from '@/constants/states';

const listItems = (
  intl,
  value,
  commonsMode,
  visibilityOptions,
) => visibilityOptions.map((visibility) => {
  const visibilityPrefix = commonsMode ? 'visibility.commons.mode' : 'visibility';

  return {
    active: visibility === value,
    description: intl.formatMessage({ id: `visibility.simple.${visibility}` }),
    icon: visibilityIcon[visibility],
    key: `dataset_visibility_dropdown_item_${visibility}`,
    text: intl.formatMessage({ id: `${visibilityPrefix}.${visibility}` }),
    value: visibility,
  };
});

const VisibilityDropdown = ({
  className,
  commonsMode,
  disabled,
  onChange,
  trigger,
  visibility,
  visibilityOptions = Object.values(entityVisibility),
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className={clsx('aridhia-visibility-dropdown max-content primary', className)}
      direction="left"
      disabled={disabled}
      fluid={!trigger}
      icon={trigger ? null : undefined}
      onChange={(e, { value }) => onChange({ visibility: value })}
      options={listItems(intl, visibility, commonsMode, visibilityOptions)}
      selection={!trigger}
      trigger={trigger}
      value={visibility}
    />
  );
};

export default VisibilityDropdown;
